import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=3b42170b"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b42170b')) {
      api.createRecord('3b42170b', component.options)
    } else {
      api.reload('3b42170b', component.options)
    }
    module.hot.accept("./RoleList.vue?vue&type=template&id=3b42170b", function () {
      api.rerender('3b42170b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/RoleList.vue"
export default component.exports